const STATUS_META = {
  delivered: { cls: "bg-obsidian text-white" },
  "in-transit": { cls: "bg-acid text-white" },
  in_transit: { cls: "bg-acid text-white" },
  "out-for-delivery": { cls: "bg-blaze text-white" },
  out_for_delivery: { cls: "bg-blaze text-white" },
  pending_assignment: { cls: "bg-zinc-900 text-sky-300" },
  manifested: { cls: "bg-zinc-200 text-obsidian" },
  pickup_scheduled: { cls: "bg-zinc-200 text-obsidian" },
  pickup_pending: { cls: "bg-zinc-200 text-obsidian" },
  picked_up: { cls: "bg-acid text-white" },
  pickup_completed: { cls: "bg-acid text-white" },
  created: { cls: "bg-zinc-200 text-obsidian" },
  rto: { cls: "bg-red-600 text-white" },
  cancelled: { cls: "bg-red-600 text-white" },
  ndr: { cls: "bg-red-600 text-white" },
  approved: { cls: "bg-obsidian text-white" },
  pending: { cls: "bg-acid text-white" },
  rejected: { cls: "bg-red-600 text-white" },
  active: { cls: "bg-obsidian text-white" },
  synced: { cls: "bg-obsidian text-white" },
  open: { cls: "bg-acid text-white" },
  closed: { cls: "bg-zinc-200 text-obsidian" },
  resolved: { cls: "bg-obsidian text-white" },
};

export const StatusBadge = ({ status }) => {
  const key = String(status || "unknown").toLowerCase();
  const meta = STATUS_META[key] || { cls: "bg-zinc-200 text-obsidian" };
  const label = key.replace(/[_-]/g, " ");
  return (
    <span
      data-testid={`status-badge-${key.replace(/[^a-z0-9]/g, "-")}`}
      className={`inline-block px-2 py-0.5 text-[11px] font-mono font-medium uppercase tracking-wider whitespace-nowrap ${meta.cls}`}
    >
      {label}
    </span>
  );
};
